import { createContext, useContext } from 'react';
import type { BranchOption, DeviceOption, TenantProfile } from '@order-pilot/shared';
import type { ReportFiltersState } from '@/features/portal/filters';

export interface PortalContextValue {
  /** From GET /portal/me, falling back to the profile cached at login. */
  profile: TenantProfile | null;
  /** Tenant's reporting currency — every money figure is labelled with it. */
  currency: string;
  /** Tenant's IANA timezone; "today" is resolved in it, never in the browser's. */
  timezone: string;
  branches: BranchOption[];
  /** False for single-branch tenants: the branch filter is not rendered at all. */
  multiBranch: boolean;
  devices: DeviceOption[];
  /**
   * False for single-till tenants — the Device filter is not rendered at all,
   * exactly like the branch one. Most cafes have one till and would only be
   * offered a control with a single option.
   */
  multiDevice: boolean;
  /** URL-backed report filters shared by the chrome and every page. */
  filters: ReportFiltersState;
}

const PortalContext = createContext<PortalContextValue | null>(null);

export const PortalContextProvider = PortalContext.Provider;

export function usePortal(): PortalContextValue {
  const context = useContext(PortalContext);
  if (context === null) throw new Error('usePortal must be used inside <PortalLayout>.');
  return context;
}
